import { gsap } from 'gsap';

export default class GradientImage {
    constructor(query) {
        const el = document.querySelector(query);
        if (!el) return;

        this.el = el;
        this.gradient = this.el.querySelector('#movingGradient');
        this.tween = null;
        this.resetTween = null;
        this.observer = null;

        if (!this.gradient) return;

        this.init();
    }

    init() {
        this.initLogoAnimation();
    }

    initLogoAnimation() {
        this.observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        this.playLogoAnimation();
                    } else {
                        this.resetLogoAnimation();
                    }
                });
            },
            { threshold: 0.35 }
        );

        this.observer.observe(this.el);
    }

    playLogoAnimation() {
        if (this.tween) return;

        if (this.resetTween) {
            this.resetTween.kill();
            this.resetTween = null;
        }

        const svg = this.el.querySelector('svg');
        const { width } = svg.viewBox.baseVal;

        this.tween = gsap.timeline({
            repeat: -1,
            repeatDelay: 4,
        });

        this.tween
            .set(this.gradient, {
                attr: {
                    x1: -width,
                    x2: 0,
                },
            })
            .to(this.gradient, {
                attr: {
                    x1: width,
                    x2: width * 2,
                },
                duration: 3,
                ease: 'none',
            });
    }

    resetLogoAnimation() {
        if (this.tween) {
            this.tween.kill();
            this.tween = null;
        }

        gsap.set(this.gradient, {
            attr: {
                x1: -1236,
                x2: 0,
            },
        });
    }

    destroy() {
        if (this.observer) {
            this.observer.disconnect();
            this.observer = null;
        }

        this.resetLogoAnimation();
    }
}